import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
  selector: 'app-modal-pdf-viewer-component',
  templateUrl: './modal-pdf-viewer-component.component.html',
  styleUrls: ['./modal-pdf-viewer-component.component.css']
})
export class ModalPdfViewerComponentComponent implements OnInit {
  private fileContent = null;

  constructor(@Inject(MAT_DIALOG_DATA) public data: { fileUrl: string, fileName: string }, private _sanitizer: DomSanitizer) {
    this.fileContent = this._sanitizer.bypassSecurityTrustResourceUrl(this.data.fileUrl);
  }

  ngOnInit(): void {
  }

  getUrl() {
    return this.fileContent;
  }
}
